import React from 'react';
import { FormattedMessage } from 'react-intl';

import UserDateTimezoneFormat from '../../../../../../components/user-date-timezone-format';
import { advancedShippingNoticeGridProperties } from '../grid-properties';
import { messages } from '../messages';

const name = <FormattedMessage {...messages.dateCreatedColumnHeader} />;

/**
 * Date Created column configuration
 * Displays the creation date formatted
 * Uses UserDateTimezoneFormat to format the date according to user's timezone
 * @type {import('./types').GridColumn} Column configuration object
 */
export const dateCreatedColumn = {
  name,
  render: (data) => {
    const { createdAt } = data;
    return createdAt && <UserDateTimezoneFormat dateTime={createdAt} />;
  },
  id: advancedShippingNoticeGridProperties.dateCreated,
};
